import React from "react";
import { MatApoyo } from "../Generals";
import { useSelector } from "react-redux";
import { getObjetoAutoridad } from "../../../Generals/autoridadesElectorales";

export default function Lesson6({ idLesson, data, setLoading, objEntidad, origen }) {

  //Se obtiene el Entidad seleccionada del store de redux
  const { entidad, idEntidad } = useSelector((state) => state.entidad);


  if(idEntidad!==undefined){
    localStorage.setItem('idEntidad', idEntidad);
  }

  const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ? objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }

  return (
    <div className="texto_parrafo">
      <p>
        La nulidad puede darse a nivel elección o a nivel votación y los efectos de cada una son los siguientes:
      </p>
      <p>
        <ol className="listNumber">
          <li>
           <b>Nulidad de la elección</b> La elección queda anulada y en consecuencia deberá celebrarse una elección extraordinaria
          </li>
          <li>
            <b>Nulidad de la votación recibida en las casillas. </b> La votación de la casilla es anulada y en consecuencia los 
            votos recibidos en ella no contarán en los cómputos finales
          </li>
        </ol>
      </p>
      <p>
        <b>Las causales de nulidad de la elección</b> son las irregularidades que se han presentado durante cualquiera de las 
        etapas del proceso electoral y que constituyen violaciones a alguno de los principios constitucionales.
      </p>
      <p>
        <b>Las causales de nulidad de la votación</b> tienen que ver con el incumplimiento de los procedimientos establecidos 
        en la legislación para la instalación de la casilla, la recepción de la votación, el cómputo de los votos y el traslado 
        de los paquetes electorales.
      </p>
      <p>
        Las causales de nulidad de la votación a nivel local se establecen en {getObjetoAutoridad(parseInt(getDataEntidad().idEntidad)).nulidadL6}
      </p>
      <p>
        Te invitamos a ver el siguiente video donde te explicamos los diferentes momentos en que se pueden presentar las causales 
        de nulidad de la votación durante el desarrollo de la Jornada Electoral.
      </p>
        {data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}<br/><br/>
      <p>
        Para repasar la información te invitamos realizar la siguiente actividad: 
      </p>
      {data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}<br/><br/>
      <p>
        ¿Sabes qué son los medios de impugnación? 
      </p>
      <p>
        Son el conjunto de <b>recursos y juicios</b> que tienen derecho a interponer las y los ciudadanos, los partidos políticos y las 
        candidaturas independientes en contra de los actos y resoluciones de las autoridades electorales, cuando éstos, a criterio 
        de quienes se inconforman, presentan deficiencias o errores.
      </p>
      <p>
        Los medios de impugnación sirven para <b>modificar, revocar o anular</b> los actos y las resoluciones en materia electoral que no 
        se apeguen a las normas jurídicas.
      </p>
      <p>
        A nivel local, estos recursos se encuentran previstos en {getObjetoAutoridad(parseInt(getDataEntidad().idEntidad)).impugnacionL6} Revisa 
        el siguiente material para conocerlos.
      </p>
      <p>
        Para profundizar en los temas de medios de impugnación a nivel local consulta el <b className="textoResaltado2"> CAPÍTULO 6 DE TU {data && data.indexOf(4) && <MatApoyo array={[data[4]]} tipo={1} />}</b> que se 
        encuentra disponible en los materiales de consulta de este curso. 
      </p>
      <p>
        A continuación, revisa el siguiente material de apoyo para reforzar lo que aprendiste.
      </p>
      {data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}
      <p>
        A continuación, realiza la actividad autoevaluable correspondiente para continuar con la siguiente lección.
      </p>
    </div>
  );
}
